export { default as IconStroke } from './icon'



// WEBPACK FOOTER //
// ./src/components/atoms/iconStroke/index.ts